import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import { Badge } from "../ui/badge";
import { NewsItem } from "../../types/news";

interface NewsDialogProps {
  newsItem: NewsItem | null;
  onClose: () => void;
}

export const NewsDialog = ({ newsItem, onClose }: NewsDialogProps) => {
  if (!newsItem) {
    return null;
  }

  return (
    <Dialog open={!!newsItem} onOpenChange={open => !open && onClose()}>
      <DialogContent className="flex h-[80vh] max-w-3xl flex-col gap-0 overflow-hidden bg-white p-0">
        <DialogHeader className="border-b border-border/40 bg-white p-6 pb-2">
          <div className="mb-3 flex items-center gap-2">
            <Badge className="bg-[#0c4a6e] text-white hover:bg-[#0c4a6e]">
              {newsItem.category}
            </Badge>
          </div>
          <DialogTitle className="text-2xl font-black leading-tight text-[#0c4a6e] md:text-3xl">
            {newsItem.title}
          </DialogTitle>
          <DialogDescription className="mt-2 text-base font-medium text-slate-600">
            {newsItem.caption}
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="flex-1 bg-white p-6 md:p-8">
          <div
            className="prose prose-lg prose-slate max-w-none leading-relaxed text-slate-700"
            dangerouslySetInnerHTML={{ __html: newsItem.content }}
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
